import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

const InternalLink = styled(Link)`
	position: relative;
	box-shadow: none;

	&::after {
		content: '';
		left: 0px;
		right: 0px;
		bottom: 0px;
		height: 2px;
		border-radius: 2px;
		position: absolute;
		background-color: var(--color-primary);
		transition: transform 200ms ease 150ms, opacity 350ms ease 150ms;
	}

	&:hover::after {
		opacity: 0;
		transform: translateY(-0.25em);
		transition: transform 200ms ease 0s, opacity 350ms ease 0s;
	}
`;

const StyledExternalLink = styled.a`
	box-shadow: none;
	position: relative;
	font-weight: var(--font-weight-extra-bold);

	&::after {
		content: '';
		left: 0px;
		right: 0px;
		height: 2px;
		bottom: -3px;
		border-radius: 1px;
		position: absolute;
		background-color: var(--color-primary);
		transition: transform 200ms ease 150ms, opacity 350ms ease 150ms;
	}

	&:hover::after {
		opacity: 0;
		transform: translateY(-0.25em);
		transition: transform 200ms ease 0s, opacity 350ms ease 0s;
	}
`;

const ExternalLink = ({ href, className, children }) => (
	<StyledExternalLink
		href={href}
		className={className}
		target="_blank"
		rel="noopener noreferrer"
	>
		{children}
	</StyledExternalLink>
);

export { InternalLink, ExternalLink };
